export default "__VITE_ASSET__BFTNv5qc__"